<template>
  <div class="row admin-company">
    <div class="col">
      <div
        class="d-flex operation-table-actions align-items-center justify-content-start"
      >
        <router-link class="btn btn-back btn-lg" to="/admin" tag="button">
          <i class="fa fa-angle-left px-1"></i>
        </router-link>
        <h2 class="ml-4">{{ company.name }}</h2>
      </div>
      <div class="row">
        <div class="col mt-5">
          <table class="table table-responsive admin-company__table">
            <thead>
              <tr>
                <th class="px-4">№</th>
                <th class="px-4">Имя</th>
                <th class="px-4">Почт. Адрес</th>
                <th class="px-4">Должность</th>
                <th class="px-4">Статус</th>
                <th class="px-4"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in users" :key="user.id">
                <td class="px-4">
                  {{ index + 1 }}
                </td>
                <td class="px-4">
                  {{ `${user.firstname} ${user.lastname}` }}
                </td>
                <td class="px-4">
                  {{ user.email }}
                </td>
                <td class="px-4">
                  {{ user.position }}
                </td>
                <td class="px-4">
                  <div class="admin-company__property-pill" v-if="user.enabled">
                    <span>активный</span>
                  </div>
                  <div
                    class="admin-company__property-pill admin-company__property-pill--disabled"
                    v-else
                  >
                    <span>не активный</span>
                  </div>
                </td>
                <td class="px-4">
                  <button
                    v-if="!user.enabled"
                    type="button"
                    class="btn btn-sm btn-outline-primary px-3"
                    @click="activate(user.id)"
                  >
                    <i class="fa fa-play" />
                  </button>
                  <button
                    v-else
                    type="button"
                    class="btn btn-sm btn-outline-primary px-3"
                    @click="deactivate(user.id)"
                  >
                    <i class="fa fa-pause" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary px-3 ml-2"
                    @click="deleteUser(user.id)"
                  >
                    <i class="ico ico-delete" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { sortBy } from 'lodash'

const roleNames = [
  { name: 'shared.after_printer', id: 'ROLE_AFTER_PRINTER' },
  { name: 'shared.printer', id: 'ROLE_PRINTER' },
  { name: 'shared.designer', id: 'ROLE_DESIGNER' },
  { name: 'shared.manager', id: 'ROLE_MANAGER' },
  { name: 'shared.director', id: 'ROLE_ADMIN' },
  { name: 'shared.master', id: 'ROLE_MASTER' },
  { name: 'shared.accountant', id: 'ROLE_ACCOUNTANT' },
  { name: 'shared.ad_agent', id: 'ROLE_AD_AGENT' }
]

export default {
  name: 'AdminCompany',
  props: {
    companyId: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      company: {},
      users: []
    }
  },
  async created () {
    await this.loadUsers()
  },
  methods: {
    async loadUsers () {
      try {
        const resp = await api.get.companyUsers(this.companyId)
        this.users = sortBy(resp.data.data.users, 'id').map((user) => {
          return {
            ...user,
            position: this.$t(
              roleNames.find((x) => x.id === user.roles)?.name ?? ''
            )
          }
        })
        this.company = this.users[0]?.customer ?? {}
      } catch (ex) {
        console.log(ex)
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async activate (id) {
      try {
        await api.post.updateUser(id, { enabled: true })
        await this.loadUsers()
        this.$notify({
          message: 'Пользователь активирован',
          type: 'success'
        })
      } catch {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async deactivate (id) {
      try {
        await api.post.updateUser(id, { enabled: false })
        await this.loadUsers()
        this.$notify({
          message: 'Пользователь деактивирован',
          type: 'success'
        })
      } catch (ex) {
        console.log(ex)
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async deleteUser (id) {
      try {
        this.$modal.show('dialog', {
          title: 'Внимание!',
          text: 'Вы уверены что хотите удалить?',
          buttons: [
            {
              title: 'Нет'
            },
            {
              title: 'Да',
              default: true,
              handler: async () => {
                await api.get.deleteUser(id)
                await this.loadUsers()
                this.$notify({
                  message: 'Пользователь удален',
                  type: 'success'
                })
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      } catch {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.admin-company {
  &__property-pill {
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: 125px;
    height: 17px;
    color: #fff;
    background-color: #28bd8b;
    border-radius: 4px;

    &--disabled {
      background-color: #f34d65;
    }
  }
}
</style>
